var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert_container"},[_c('div',{ref:"alertBottom",staticClass:"alert fade show",class:[_vm.alertShow ? 'alert__show' : 'alert__hide', 'bg-' + _vm.alertType]},[_vm._v(" "+_vm._s(_vm.alertMessage)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }